import { Region } from "../../constants/action-constants/RegionActionConstants";

//intital state
const initialState = {
  regionDataLoading: false,
  regionDataError: "",
  regionData: {},

  // REGIONS NAME
  namesLoading: false,
  namesError: "",
  regionsName: [],

  // PINCODE RANKING BY TG
  pincodeRankingLoading: false,
  pincodeRanking: [],
  rankedBoundariesPolygonData: {},
  appliedTgAttrMapForRanking: {},
  pincodeRankingError: "",
  selectedTgAttrForRanking: {},
};

// get Ranked Boundaries Polygon Data
function getRankedBoundariesPolygonData(
  rankedPincodesArray = [],
  boundaryPolygonData = {}
) {
  // no data case
  if (rankedPincodesArray.length === 0 || !boundaryPolygonData) {
    return {};
  }

  // filter the polygon data to only include the ranked pincodes
  const { features } = boundaryPolygonData || {};

  // top 10 pincodes in ranking
  const top10Pincodes = rankedPincodesArray.slice(0, 10);

  // creating map of features by name for easy loop
  const featureMap = Object.fromEntries(
    features.map((feature) => [feature?.properties?.name, feature])
  );

  const filteredResponse = {
    ...boundaryPolygonData,
    features: top10Pincodes
      .map((pincode) => featureMap[pincode])
      .filter(Boolean),
  };

  return filteredResponse;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case Region.GET_REGION_DATA_BY_CITY:
      return {
        ...state,
        regionDataLoading: true,
      };
    case Region.GET_REGION_DATA_BY_CITY_SUCCESS:
      return {
        ...state,
        regionData: action.payload.regionDataObject,
        regionDataLoading: false,
      };

    case Region.GET_REGION_DATA_BY_CITY_FAILURE:
      return {
        ...state,
        regionDataLoading: false,
        regionDataError: action.payload,
      };

    case Region.CLEAR_REGION_DATA_BY_CITY:
      return {
        ...state,
        regionData: {},
      };

    case Region.GET_REGION_NAMES:
      return {
        ...state,
        namesLoading: true,
      };

    case Region.GET_REGION_NAMES_SUCCESS: {
      const nameItems = Object.keys(action.regionsNames).map((key) => {
        return {
          id: `${action.regionsNames[key]}`,
          label: key,
        };
      });
      return {
        ...state,
        regionsName: nameItems,
        namesLoading: false,
      };
    }

    case Region.GET_REGION_NAMES_FAILURE:
      return {
        ...state,
        namesLoading: false,
        namesError: action.payload,
      };

    // PINCODE RANKING BY TG
    case Region.GET_PINCODE_RANKING_BY_TG:
      return {
        ...state,
        pincodeRankingLoading: true,
        pincodeRanking: [],
        rankedBoundariesPolygonData: {},
      };

    case Region.GET_PINCODE_RANKING_BY_TG_SUCCESS: {
      const { pincodeRanking, polygonData, appliedTgAttrMap } =
        action.payload || {};

      // ranked pincode boundaries data
      const rankedBoundariesPolygonData = getRankedBoundariesPolygonData(
        pincodeRanking,
        polygonData
      );

      return {
        ...state,
        pincodeRankingLoading: false,
        pincodeRanking: pincodeRanking,
        rankedBoundariesPolygonData: rankedBoundariesPolygonData,
        appliedTgAttrMapForRanking: appliedTgAttrMap,
      };
    }

    case Region.GET_PINCODE_RANKING_BY_TG_FAILURE:
      return {
        ...state,
        pincodeRankingLoading: false,
        pincodeRankingError: action.payload,
      };

    case Region.CLEAR_PINCODE_RANKING_BY_TG:
      return {
        ...state,
        pincodeRankingLoading: false,
        pincodeRanking: [],
        rankedBoundariesPolygonData: {},
        appliedTgAttrMapForRanking: {},
        pincodeRankingError: "",
        selectedTgAttrForRanking: {},
      };

    case Region.SELECT_TG_ATTR_FOR_RANKING: {
      const { attrGroup, attrName } = action.payload;

      const existingAttrGroupData =
        state.selectedTgAttrForRanking?.[attrGroup] || [];

      return {
        ...state,
        selectedTgAttrForRanking: {
          ...state.selectedTgAttrForRanking,
          [attrGroup]: [...existingAttrGroupData, attrName],
        },
      };
    }

    case Region.UNSELECT_TG_ATTR_FOR_RANKING: {
      const { attrGroup, attrName } = action.payload;

      const existingAttrGroupData =
        state.selectedTgAttrForRanking?.[attrGroup] || [];
      const updatedSelectedTgAttrForRanking = {
        ...state.selectedTgAttrForRanking,
        [attrGroup]: existingAttrGroupData.filter((attr) => attr !== attrName),
      };

      return {
        ...state,
        selectedTgAttrForRanking: updatedSelectedTgAttrForRanking,
      };
    }

    default:
      return state;
  }
};
